module.exports = __webpack_public_path__ + "img/bm.09839e2c.svg";